<div class="modal-header">
  <h4 class="modal-title">Multiple Files Transcription</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <!-- File Selection Section -->
  <div *ngIf="!parsedData" class="file-selection-section">
    <div class="file-upload-area">
      <input
        type="file"
        #fileInput
        (change)="onFileSelected($event)"
        multiple
        accept="audio/*"
        hidden
      />
      <button class="btn btn-primary" (click)="browseFiles()">
        <i class="fa fa-plus"></i> Add Files
      </button>
      <p class="mt-2">Select multiple audio files for transcription</p>
    </div>

    <div class="selected-files mt-3" *ngIf="selectedFiles.length > 0">
      <h5>Selected Files ({{ selectedFiles.length }})</h5>
      <div class="file-list">
        <div
          class="file-item"
          *ngFor="let file of selectedFiles; let i = index"
        >
          <div class="file-info">
            <i class="fa fa-file-audio-o"></i>
            <span class="file-name">{{ file.name }}</span>
            <span class="file-size"
              >({{ (file.size / 1024 / 1024).toFixed(2) }} MB)</span
            >
          </div>
          <button class="btn btn-sm btn-danger" (click)="removeFile(i)">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="mt-3" *ngIf="isSubmitting || isProcessing">
      <div
        *ngIf="isSubmitting && !isProcessing"
        class="d-flex flex-column align-items-center"
      >
        <label class="mb-1 d-flex align-items-center justify-content-center">
          <strong>Uploading Files</strong>
          <span class="ml-2"><i class="fa fa-spinner fa-spin"></i></span>
        </label>
        <div class="progress w-100">
          <div
            class="progress-bar"
            role="progressbar"
            [style.width]="uploadProgress + '%'"
            attr.aria-valuenow="{{ uploadProgress }}"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {{ uploadProgress }}%
          </div>
        </div>
      </div>
      <div *ngIf="isProcessing" class="d-flex flex-column align-items-center">
        <label class="mb-1 d-flex align-items-center justify-content-center">
          <strong>Processing Files</strong>
          <span class="ml-2"><i class="fa fa-spinner fa-spin"></i></span>
        </label>
      </div>
    </div>

    <div class="submit-section mt-3">
      <button
        class="btn btn-primary"
        [disabled]="selectedFiles.length === 0 || isSubmitting"
        (click)="submitFiles()"
      >
        <i
          class="fa"
          [ngClass]="isSubmitting ? 'fa-spinner fa-spin' : 'fa-paper-plane'"
        ></i>
        {{ isSubmitting ? "Processing..." : "Submit for Transcription" }}
      </button>
    </div>
  </div>

  <!-- Results Section -->
  <div *ngIf="parsedData" class="results-section">
    <div class="row">
      <div class="col-md-6">
        <h5>
          <button class="copy-btn" (click)="copySection('orders')">
            <i class="fas fa-thumbtack"></i>
          </button>
          Orders
        </h5>
        <p *ngIf="!parsedData?.Order?.length">NONE</p>
        <ul *ngIf="parsedData?.Order?.length" #orders>
          <li *ngFor="let order of parsedData.Order">
            <strong>Type:</strong> {{ order.type }} <br />
            <strong>Order:</strong> {{ order.order }} <br />
            <strong>Description:</strong> {{ order.description }}
          </li>
        </ul>

        <h5>
          <button class="copy-btn" (click)="copySection('doctorNotes')">
            <i class="fas fa-thumbtack"></i>
          </button>
          Doctor Notes
        </h5>
        <div *ngIf="parsedData?.doctor_notes" #doctorNotes>
          <ng-container
            *ngIf="
              !(
                parsedData.doctor_notes['History Of Present Illness'] &&
                parsedData.doctor_notes['History Of Present Illness'].History
              )
            "
          >
            <p><strong>History of Present Illness:</strong></p>
            <p>{{ parsedData.doctor_notes["History Of Present Illness"] }}</p>
          </ng-container>
          <ng-container
            *ngIf="
              parsedData.doctor_notes['History Of Present Illness'] &&
              parsedData.doctor_notes['History Of Present Illness'].History
            "
          >
            <p><strong>History of Present Illness:</strong></p>
            <p>
              {{
                parsedData.doctor_notes["History Of Present Illness"].History
              }}
            </p>
            <span style="font-weight: 500">Location :</span>
            <p>
              {{
                parsedData.doctor_notes["History Of Present Illness"].Location
              }}
            </p>
            <span style="font-weight: 500">Quality :</span>
            <p>
              {{
                parsedData.doctor_notes["History Of Present Illness"].Quality
              }}
            </p>
            <span style="font-weight: 500">Severity :</span>
            <p>
              {{
                parsedData.doctor_notes["History Of Present Illness"].Severity
              }}
            </p>
            <span style="font-weight: 500">Duration :</span>
            <p>
              {{
                parsedData.doctor_notes["History Of Present Illness"].Duration
              }}
            </p>
            <span style="font-weight: 500">Context :</span>
            <p>
              {{
                parsedData.doctor_notes["History Of Present Illness"].Context
              }}
            </p>
            <span style="font-weight: 500">Timing :</span>
            <p>
              {{ parsedData.doctor_notes["History Of Present Illness"].Timing }}
            </p>
            <span style="font-weight: 500"
              >Associated Signs and Symptoms :</span
            >
            <p>
              {{
                parsedData.doctor_notes["History Of Present Illness"][
                  "Associated Signs and Symptoms"
                ]
              }}
            </p>
            <span style="font-weight: 500">Modifying Factors :</span>
            <p>
              {{
                parsedData.doctor_notes["History Of Present Illness"][
                  "Modifying Factors"
                ]
              }}
            </p>
          </ng-container>

          <p><strong>Physical Examination:</strong></p>
          <p>{{ parsedData.doctor_notes["Physical Examination"] }}</p>

          <p><strong>Diagnostics:</strong></p>
          <p>{{ parsedData.doctor_notes["Orders"] }}</p>

          <p><strong>Assessment/Plan:</strong></p>
          <p>{{ parsedData.doctor_notes["Assessment/Plan"] }}</p>
        </div>

        <h5>
          <button class="copy-btn" (click)="copySection('recommendations')">
            <i class="fas fa-thumbtack"></i>
          </button>
          Recommendations
        </h5>
        <div *ngIf="parsedData?.recommendations" #recommendations>
          <p *ngIf="parsedData?.recommendations?.tests?.length">
            <strong>Tests:</strong>
          </p>
          <ul>
            <li *ngFor="let test of parsedData.recommendations.tests">
              {{ test.name }} - {{ test.reason }}
            </li>
          </ul>

          <p *ngIf="parsedData?.recommendations?.medications?.length">
            <strong>Medications:</strong>
          </p>
          <ul>
            <li *ngFor="let med of parsedData.recommendations.medications">
              {{ med.name }} - {{ med.dosage }} ({{ med.purpose }})
            </li>
          </ul>

          <p *ngIf="parsedData?.recommendations?.treatments?.length">
            <strong>Treatments:</strong>
          </p>
          <ul>
            <li *ngFor="let treatment of parsedData.recommendations.treatments">
              {{ treatment.name }} - {{ treatment.description }}
            </li>
          </ul>

          <p *ngIf="parsedData?.recommendations?.considerations?.length">
            <strong>Considerations:</strong>
          </p>
          <p>{{ parsedData.recommendations.considerations }}</p>
        </div>
      </div>

      <div class="col-md-6">
        <h5>
          <button class="copy-btn" (click)="copySection('transcription')">
            <i class="fas fa-thumbtack"></i>
          </button>
          Transcription
        </h5>
        <div *ngIf="transcriptionData" #transcription>
          <p>{{ transcriptionData }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="activeModal.close()">Close</button>
</div>
